import React, { useEffect, useState } from "react";

import {
  DashboardEditorProps,
  IGanttChartEditor,
  IProductTemplateTableEditor,
} from "components/ComponentType";
import {
  IProductTemplateDropdownChangeEvent,
  ProductTemplateDropdown,
} from "components/basic/dropdowns/product-template/ProductTemplateDropdown";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import ProductTemplateConfig from "components/dashboard/product-template-table/product-template-table-editor/ProductTemplateConfig";
import { defaultProductTemplateEditorConfig } from "components/dashboard/product-template-table/product-template-table-editor/ProductTemplateTableEditor";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import GanttChartConfig from "./components/GanttChartConfig";

const GanttChartEditor: React.FC<DashboardEditorProps<IGanttChartEditor>> = ({
  config,
  onConfigChange,
}) => {
  const [currentConfig, setCurrentConfig] = useState<IGanttChartEditor>(() => {
    if (Object.keys(config).length > 0) {
      return config;
    }
    return {
      ...defaultProductTemplateEditorConfig,
      ganttRanges: [],
      ganttTimestamps: [],
      height: undefined,
      columnOverrideYLabels: "",
      showLegends: true,
    };
  });

  useEffect(() => {
    onConfigChange(currentConfig);
  }, [currentConfig]);

  const safeNameSelectionHandler = (e: IProductTemplateDropdownChangeEvent) => {
    setCurrentConfig(prevState => ({ ...prevState, safeName: e.refName, id: e.value }));
  };

  const handleIsRelativeChange = (e: InputSwitchChangeEvent) => {
    const newConfig = {
      ...currentConfig,
      isRelative: e.value,
      height: undefined,
      columnOverrideYLabels: "",
      aggregateY: undefined,
      showLegends: undefined,
      valueColumn: undefined,
      startColumn: undefined,
      endColumn: undefined,
    };
    setCurrentConfig(newConfig);
  };

  return (
    <div className="grid p-fluid gap-3">
      <div className="w-full flex flex-row gap-3">
        <div className="w-8 mt-3 flex flex-column">
          <label htmlFor="safeName">{T("label.product-template-table")}</label>
          <ProductTemplateDropdown value={currentConfig.id} onChange={safeNameSelectionHandler} />
        </div>
        <div className="w-4 mt-3 flex flex-column gap-2">
          <label htmlFor="isRelative">{T("label.use-relative-gantt-chart")}</label>
          <InputSwitch
            id="isRelative"
            checked={currentConfig.isRelative ?? false}
            onChange={handleIsRelativeChange}
          />
        </div>
      </div>
      <TabView className="w-full">
        <TabPanel header={T("word.chart")}>
          <GanttChartConfig currentConfig={currentConfig} setCurrentConfig={setCurrentConfig} />
        </TabPanel>
        <TabPanel header={T("word.table")}>
          <ProductTemplateConfig
            currentConfig={currentConfig}
            setCurrentConfig={
              setCurrentConfig as React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>
            }
          />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default GanttChartEditor;
